/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { MenuComponent } from '../../../../../../../../_metronic/assets/ts/components'
import { ID, KTSVG, QUERIES } from '../../../../../../../../_metronic/helpers'
import { useListView } from '../../core/ListViewProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { Dealer } from '../../core/_models'
import { deleteDealer, statusDealer } from '../../core/_requests'
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

type Props = {
  id: ID,
  data: Dealer
}

const MyActionsCell: FC<Props> = ({data, id }) => {
  const { setItemIdForUpdate } = useListView()
  const { query } = useQueryResponse()
  const queryClient = useQueryClient()
  const [status,setStatus]=useState(data.status)

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const openEditModal = () => {
    setItemIdForUpdate(id)
  }

  const deleteConfirm = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui bg-light'>
            <div className='gy-2 bg-primary  px-4 py-2'>
              <span className="text-light fw-bold">DELETE</span>
            </div>
            <div className="px-4 py-1">
              <div className="px-4 py-10">
                <p>Are you sure, you want to delete this data?</p>
              </div>
              <div className="px-4 py-1">
                <button
                  className='btn btn-danger mx-2'
                  onClick={async() => {
                    // this.handleClickDelete();
                     await deleteItem.mutateAsync()
                    onClose();
                  }}
                >
                  Yes, Delete it!
                </button> 
                <button className='btn btn-primary' onClick={onClose}>No</button>
              </div>
            </div>
          </div>
        );
      }
    });
  } 


  const deleteItem = useMutation(() => deleteDealer(id), {
    // 💡 response of the mutation is passed to onSuccess
    onSuccess: () => {
      // ✅ update detail view directly
      queryClient.invalidateQueries([`${QUERIES.DEALER_LIST}-${query}`])
    },
  })

  const statusItem = useMutation(() => statusDealer(id), {
    // 💡 response of the mutation is passed to onSuccess
    onSuccess: () => {
      // ✅ update status detail view directly
      //queryClient.invalidateQueries([`${QUERIES.DEALER_LIST}-${query}`])
      setStatus(status==='A'?'I':'A')
    },
  })

  return (
    <>

      <a
        title={`${status==='A' ? 'Inactive':'Active'}`}
        className={`btn btn-icon btn-bg-light  btn-sm me-1  ${status==='A' ?'btn-active-color-success active':'btn-active-color-danger active'}` }
        data-kt-dealers-table-filter='status_row'
        onClick={async () => await statusItem.mutateAsync()}
      >
        <KTSVG path='/media/icons/duotune/general/gen019.svg' className='svg-icon-3' />
       
      </a>
      <a
        
        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 btn-color-info'
        onClick={openEditModal}
      >
        <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
      </a>
      <a className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm btn-color-danger'

        data-kt-dealers-table-filter='delete_row'
        onClick={async () => await deleteConfirm()}
      >
        <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />
      </a>
    </>
  )
}

export { MyActionsCell }
